import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[positiveInteger]'
})
export class PositiveInteger {
    // Allow key codes for special events. Reflect :
    // Backspace, tab, end, home
    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home'];
    current: string;
    next: string;
    @Input() value: number;
    // regex: RegExp = new RegExp(/^\d*(\.\d{0,4})?$/g);
    regex: RegExp = new RegExp(/^\d+$/g);
    constructor(private el: ElementRef) { }
    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent) {
        const charCode = event.key.charCodeAt(0);     // Allow only digits (0-9)
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    }
    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        const clipboardData = event.clipboardData?.getData('text') || '';
        // Allow only paste of positive integer values
        if (!/^\d+$/.test(clipboardData)) {
            event.preventDefault();
        }
    }

    @HostListener('input', ['$event'])
    onInput(event: Event) {
        const input = event.target as HTMLInputElement;
        // Remove any non-numeric characters if typed/pasted 
        input.value = input.value.replace(/[^0-9]/g, '');

        // Restrict the input length to 3 characters
        if (input.value.length > 3) {
            input.value = input.value.slice(0, 3);
        }
    }
}
